export const comicFrames = [
	{
		id: 1,
		image: "/comic/frame1.png",
		text: "In a world of memes and chaos...",
		position: "left",
		prompt:
			"Digital art of a chaotic crypto trading floor, filled with meme symbols and cryptocurrency logos floating in the air. The style is comic book, with bold colors and dramatic lighting. The scene should be energetic and slightly humorous.",
	},
	{
		id: 2,
		image: "/comic/frame2.png",
		text: "A hero emerges from the blockchain...",
		position: "right",
		prompt:
			"Comic book style illustration of a muscular Trump-like figure emerging from a glowing blockchain portal. He's wearing a superhero costume in red, white, and blue. The background shows binary code and crypto symbols. The art style should be dramatic and dynamic.",
	},
	{
		id: 3,
		image: "/comic/frame3.png",
		text: "MUSCLE TRUMP! 💪",
		position: "left",
		prompt:
			"Epic comic book panel of Muscle Trump in a heroic pose, flexing his muscles. He's wearing a wrestling-style outfit with American flag colors. Behind him is a explosion of meme symbols and dollar signs. The style should be over-the-top and reminiscent of 90s superhero comics.",
	},
];
